import FreeFormFieldAttribute from '/app/javascript/bundles/KeenformRenderer/components/formelements/FreeFormFieldAttribute/FreeFormFieldAttribute';

export default class FreeFormFieldEditor extends FreeFormFieldAttribute{

  getPropsForTextInput () {
    let inputProps = super.getPropsForTextInput();
    return {
      ...inputProps,
      value: undefined,
      defaultValue: this.props.defaultValue,
    };
  }

}
